var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fg-component fg-home" }, [
    _c("div", { staticClass: "fg-home-menu-card waf-menu-card" }, [
      _c("div", { staticClass: "fg-head" }, [
        _c("h1", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.translations.game_plan_label)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fg-body" }, [
        _c(
          "div",
          { staticClass: "contest-list contest-listing" },
          _vm._l(_vm.contest_list, function (contestListItem, idx) {
            return _c("contest-item", {
              key: idx,
              attrs: {
                featuredContest: contestListItem,
                translations: _vm.translations,
              },
            })
          }),
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }